<template>
  <div>
    <zj-layout-container>
      <div style="height: 50%">
        <div class="wrap" style="width: 40%">
          <div class="title01">舆情热词</div>
          <OpinionHotWordsView></OpinionHotWordsView>
        </div>
        <div class="wrap" style="width: 30%">
          <div class="title01">媒体来源</div>
           <OpinionMediaView></OpinionMediaView>
        </div>
        <div class="wrap" style="width: 30%">
          <div class="title01">媒体来源TOP5</div>
           <OpinionMediaTop5></OpinionMediaTop5>
        </div>
      </div>
      <div style="height: 50%">
        <div class="wrap" style="width: 100%">
          <div class="title01">舆情走势</div>
          <OpinionRealTimeView></OpinionRealTimeView>
        </div>
      </div>
    </zj-layout-container>
  </div>
</template>
<script>
import OpinionHotWordsView from "./OpinionHotWords";
import OpinionMediaView from "./OpinionMedia";
import OpinionRealTimeView from "./OpinionRealTime";
import OpinionMediaTop5 from "./OpinionMediaTop5";

export default {
  name: "OpinionAnalysisManager",
  controller: "UI",
  action: "OpinionAnalysisManager",
  components: {
    OpinionHotWordsView,
    OpinionMediaView,
    OpinionRealTimeView,
    OpinionMediaTop5
  },
};
</script>

<style type="text/css">
.title {
  height: 10%;
  text-align: center;
  font-size: 3rem;
  margin-bottom: 3rem;
}
.wrap {
  position: relative;
  float: left;
  height: 100%;
}
.title01 {
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 2.4rem;
 
}
.box {
  width: 100%;
  height: 100%;
}
.box01 {
  display: inline-block;
  width: 50%;
  height: 100%;
}
.box02 {
  display: inline-block;
  width: 50%;
  height: 90%;
}
</style>